export enum PayoutRequisitesAutomationWarningType {
  ExpectedBalance = 'expected_balance',
}
